import { CACHE_CONFIG } from '../../constants';
import { AllocationStructureItem } from '../../models/allocationStructureItem';
import { withCache } from '../../util';
import apiClient from '../apiClient';

export const fetchAllocationStructures = async (
  clientId: number
): Promise<AllocationStructureItem[]> => {
  return apiClient<Array<AllocationStructureItem>>(
    `allocation/allocationstructures/${clientId}`,
  );
};

export async function fetchAllocationStructuresWithCache(
  clientId: number,
): Promise<AllocationStructureItem[]> {
  return withCache(
    () => fetchAllocationStructures(clientId),
    {
      ...CACHE_CONFIG.ALLOCATION_STRUCTURES_DROPDOWN_VALUES,
      key: `${CACHE_CONFIG.ALLOCATION_STRUCTURES_DROPDOWN_VALUES.key}-${clientId}`,
    },
  );
}
